import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const MASCOT = {
  peek: "https://customer-assets-v7afamib.emergentagent.net/job_shopee-rapido/artifacts/hcnest0m_a8e542ef-389e-401e-8ba2-b0747007f8a0.png",
  happy: "https://customer-assets-v7afamib.emergentagent.net/job_shopee-rapido/artifacts/7hzk2ip4_17ad8fa3-c6c8-44c9-9b85-891e69c03b6b.png",
  tilt: "https://customer-assets-v7afamib.emergentagent.net/job_shopee-rapido/artifacts/f6du44o4_8e059617-06ae-4485-bce5-e019117927c1.png",
};

// Autenticacao via cookie httpOnly: enviamos o cookie em toda requisicao.
const api = axios.create({ baseURL: API, withCredentials: true });

// Arquivos sao servidos no mesmo dominio; o cookie httpOnly vai junto no <img>/<video>.
export function fileUrl(url) {
  return url || null;
}

export function formatApiError(detail) {
  if (detail == null) return "Algo deu errado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
